module.exports = __webpack_public_path__ + "img/reviewMap.97b91748.svg";